import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getROPicklistEdit = get('reservation.routes.ROPicklist.edit');

export const getROPicklistEditData = createSelector(
  getROPicklistEdit,
  get('data')
);

export const getIsFetching = createSelector(getROPicklistEdit, get('fetching'));

export const getIsFetched = createSelector(getROPicklistEdit, get('fetched'));

export const getIsSaving = createSelector(getROPicklistEdit, get('saving'));

export const getIsSaved = createSelector(getROPicklistEdit, get('saved'));
